import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line import/extensions
import './i18nextConf.ts';
import './scss/index.scss';
import App from './components/App/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
